import { isUrl } from '@utils/url';

import {
    addUtmsToCopyToClipboardShareUrl,
    removeSearchParamsFromUrl,
} from '../utils/url';

export const useCopyToClipboard = () => {
    const copy = (textToCopy: string) => {
        let text = textToCopy;

        if (isUrl(text)) {
            text = removeSearchParamsFromUrl(text);
            text = addUtmsToCopyToClipboardShareUrl(text);
        }

        navigator.clipboard.writeText(text);
    };

    return { copy };
};
